// extracted by mini-css-extract-plugin
module.exports = {"container":"OneAttract_container__3Igid","mcBook":"OneAttract_mcBook__Bd4Q9","phone":"OneAttract_phone__3YF2z","spread":"OneAttract_spread__3igun"};